import type { IVScoreResponse } from "../../types/market-data";
import { FintheonNumericText } from "../numbers/FintheonNumericText";

interface EconHeaderIvIntroProps {
  data: IVScoreResponse | null;
  loading?: boolean;
}

function scoreTone(score: number) {
  if (score >= 8) return "text-red-500";
  if (score >= 6) return "text-orange-400";
  if (score >= 4) return "text-yellow-400";
  return "text-emerald-400";
}

export function EconHeaderIvIntro({ data, loading }: EconHeaderIvIntroProps) {
  if (loading || !data) {
    return (
      <div className="flex w-full items-center gap-2">
        <span className="text-[9px] text-gray-400">IV</span>
        <span className="font-mono text-xs font-bold text-gray-600">--</span>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center gap-2">
      <span className="text-[9px] text-gray-400">IV</span>
      <span className={`text-xs font-bold ${scoreTone(data.score)}`}>
        <FintheonNumericText text={String(data.score.toFixed(1))} />
      </span>
      <span className="text-[9px] font-medium text-[var(--fintheon-text)]/35">
        {data.instrument}
      </span>
      {data.points ? (
        <>
          <span className="text-[10px] text-gray-600">|</span>
          <span className="text-[10px] font-medium text-[var(--fintheon-accent)]">
            +/-{data.points.scaledPoints} pts
          </span>
        </>
      ) : null}
    </div>
  );
}
